import React from "react";
import "./page.css";

const PageLayout = ({ title, description, children }) => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <div className="content-section">{children}</div>
    </div>
  );
};

export default PageLayout;
